<template>
  <el-card shadow="hover" v-loading="loading">
    <div slot="header" class="header">
      <div class="title">
        <span>日志</span>
        <el-tag v-if="total > 0" size="mini" type="info" style="margin-left:8px;">共 {{ total }} 条</el-tag>
      </div>
      <div>
        <el-button size="small" icon="el-icon-refresh" @click="refresh">刷新</el-button>
      </div>
    </div>

    <el-table :data="list" border stripe highlight-current-row empty-text="暂无日志">
      <el-table-column prop="id" label="ID" width="90" />
      <el-table-column prop="user_id" label="用户" width="110">
        <template slot-scope="scope">
          {{ formatUserLabel(scope.row.user_id) }}
        </template>
      </el-table-column>
      <el-table-column prop="action" label="动作" min-width="140">
        <template slot-scope="scope">
          {{ actionLabel(scope.row.action) }}
        </template>
      </el-table-column>
      <el-table-column prop="ip" label="IP" width="140" />
      <el-table-column prop="created_at" label="时间" width="170">
        <template slot-scope="scope">
          {{ formatTime(scope.row.created_at) }}
        </template>
      </el-table-column>
      <el-table-column prop="detail" label="详情" min-width="280" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ formatDetailZh(scope.row.detail, scope.row.action) }}
        </template>
      </el-table-column>
    </el-table>

    <div style="height: 12px;"></div>
    <el-pagination
      background
      layout="total, sizes, prev, pager, next, jumper"
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="[10, 20, 50, 100]"
      :total="total"
      @size-change="onPageSizeChange"
      @current-change="onPageChange"
    />
  </el-card>
</template>

<script>
import { getLogs } from "@/api";

export default {
  name: "Log",
  data() {
    return {
      list: [],
      page: 1,
      pageSize: 20,
      total: 0,
      loading: false
    };
  },
  mounted() {
    this.refresh();
  },
  methods: {
    formatUserLabel(uid) {
      const n = Number(uid);
      if (!n) return "系统/设备";
      return "用户 #" + n;
    },
    actionLabel(action) {
      const map = {
        admin_bootstrap: "管理员初始化",
        admin_login: "管理员登录",
        wx_login: "微信登录",
        wx_phone: "微信绑定手机号",
        org_create: "创建机构",
        cabinet_create: "创建智能柜",
        cabinet_assign: "分配智能柜权限",
        cabinet_assign_many: "批量分配智能柜",
        cabinet_open: "远程开门",
        cabinet_open_platform: "平台远程开门",
        cabinet_open_mini_program: "小程序远程开门",
        cabinet_device_poll: "设备轮询(智能柜)",
        cabinet_device_log: "设备上报开门日志",
        role_create: "创建角色",
        role_assign: "分配角色",
        user_profile_update: "更新用户资料"
      };
      return map[action] || action || "-";
    },
    detailKeyZh(k) {
      const map = {
        cabinet_id: "智能柜ID",
        cabinet_code: "柜子编号",
        cabinetId: "智能柜ID",
        deviceId: "设备编号",
        deviceName: "设备名称",
        doorStatus: "上报柜门状态",
        door_status_saved: "已存柜门状态",
        returnData: "返回开门指令",
        code: "柜子编号",
        user_id: "用户ID",
        username: "用户名",
        phone: "手机号",
        name: "姓名",
        type: "类型",
        count: "数量",
        role_key: "角色标识",
        role_id: "角色ID",
        org_id: "机构ID",
        key: "标识",
        source: "来源"
      };
      return map[k] || k;
    },
    detailValueZh(k, v, action) {
      if (v === null || v === undefined || v === "") return "-";
      if (k === "doorStatus" || k === "door_status_saved" || k === "returnData") {
        if (String(v) === "1") return "开";
        if (String(v) === "2") return "关";
      }
      if (k === "type" && action === "wx_login") {
        if (v === "existing" || v === "existing_after_conflict") return "已有用户";
        if (v === "created") return "新注册用户";
        return String(v);
      }
      if (k === "type" && action === "cabinet_device_log") {
        const t = Number(v);
        if (t === 1) return "设备上报开门";
        return "类型" + String(v);
      }
      if (k === "type" && (action === "cabinet_open_platform" || action === "cabinet_open_mini_program")) {
        const t = Number(v);
        if (t === 2) return "平台远程开门";
        if (t === 3) return "小程序远程开门";
        return String(v);
      }
      if (k === "source") {
        if (v === "platform") return "平台";
        if (v === "mini_program") return "小程序";
      }
      if (typeof v === "object") return JSON.stringify(v);
      return String(v);
    },
    fieldNameZh(field) {
      const map = {
        nick_name: "昵称",
        avatar_url: "头像",
        phone_number: "手机号"
      };
      return map[field] || field;
    },
    formatDetailZh(raw, action) {
      if (raw === null || raw === undefined || raw === "") return "-";
      let data;
      try {
        data = typeof raw === "string" ? JSON.parse(raw) : raw;
      } catch (e) {
        return String(raw);
      }
      // 常见动作：优先输出一句话中文摘要（更适合后台列表展示）
      if (data && typeof data === "object" && !Array.isArray(data)) {
        const summary = this.summaryByAction(action, data);
        if (summary) return summary;
      }
      if (Array.isArray(data)) {
        if (data.length && typeof data[0] === "string") {
          return "更新字段：" + data.map((f) => this.fieldNameZh(f)).join("、");
        }
        return data.map((x) => JSON.stringify(x)).join("；");
      }
      if (typeof data !== "object") {
        return String(data);
      }
      const parts = [];
      // 兜底：只取前 6 个键，避免过长
      Object.keys(data).slice(0, 6).forEach((k) => {
        const label = this.detailKeyZh(k);
        const val = this.detailValueZh(k, data[k], action);
        parts.push(label + "：" + val);
      });
      return parts.length ? parts.join("；") : "-";
    },
    summaryByAction(action, d) {
      const deviceId = d.deviceId || d.cabinet_code || d.code || "";
      const deviceName = d.deviceName || d.name || "";
      const who = d.username || d.nickName || d.name || "";

      if (action === "admin_login") {
        return `管理员登录：${d.username ? "账号" + d.username : "成功"}`;
      }
      if (action === "wx_login") {
        const t = d.type === "created" ? "新注册" : "登录";
        return `微信${t}`;
      }
      if (action === "org_create") {
        return `创建机构：${d.name || "-"}`;
      }
      if (action === "cabinet_create") {
        const code = d.code || "";
        return `创建智能柜：${code ? "编号" + code : "成功"}`;
      }
      if (action === "cabinet_assign") {
        return `分配智能柜权限：用户#${d.user_id || "-"} → 柜#${d.cabinet_id || "-"}`;
      }
      if (action === "cabinet_assign_many") {
        return `批量分配智能柜：用户#${d.user_id || "-"}，数量${d.count || 0}`;
      }
      if (action === "cabinet_open_platform" || action === "cabinet_open_mini_program") {
        const from = action === "cabinet_open_platform" ? "平台远程开门" : "小程序远程开门";
        const dev =
          deviceId && deviceName ? `设备${deviceId}（${deviceName}）` :
          deviceId ? `设备${deviceId}` :
          (d.cabinet_id ? `柜#${d.cabinet_id}` : "设备未知");
        const op = d.name ? `，操作人：${d.name}` : "";
        return `${from}：${dev}${op}`;
      }
      if (action === "cabinet_device_log") {
        const dev =
          (d.deviceId && d.deviceName) ? `设备${d.deviceId}（${d.deviceName}）` :
          d.deviceId ? `设备${d.deviceId}` :
          (d.cabinet_id ? `柜#${d.cabinet_id}` : "设备未知");
        const op = d.name ? `，人员：${d.name}` : "";
        return `设备上报开门：${dev}${op}`;
      }
      if (action === "cabinet_device_poll") {
        const dev =
          (d.deviceId && d.deviceName) ? `设备${d.deviceId}（${d.deviceName}）` :
          d.deviceId ? `设备${d.deviceId}` : "设备轮询";
        const door = d.doorStatus ? `，柜门：${this.detailValueZh("doorStatus", d.doorStatus, action)}` : "";
        const cmd = d.returnData ? `，指令：${this.detailValueZh("returnData", d.returnData, action)}` : "";
        return `设备轮询：${dev}${door}${cmd}`;
      }
      if (action === "user_profile_update") {
        return "";
      }
      return "";
    },
    formatTime(ts) {
      const t = Number(ts || 0) * 1000;
      if (!t) return "";
      const d = new Date(t);
      const pad = (n) => String(n).padStart(2, "0");
      return (
        d.getFullYear() +
        "-" +
        pad(d.getMonth() + 1) +
        "-" +
        pad(d.getDate()) +
        " " +
        pad(d.getHours()) +
        ":" +
        pad(d.getMinutes()) +
        ":" +
        pad(d.getSeconds())
      );
    },
    onPageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.refresh();
    },
    onPageChange(p) {
      this.page = p;
      this.refresh();
    },
    async refresh() {
      const ps = Math.min(100, Math.max(1, Number(this.pageSize || 20)));
      this.pageSize = ps;
      this.loading = true;
      try {
        const res = await getLogs({ page: this.page, pageSize: ps });
        const data = (res && res.data) || {};
        this.list = data.list || [];
        this.total = Number(data.total != null ? data.total : 0);
      } catch (e) {
        this.$message.error("加载失败（需要 admin 权限）");
        this.list = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.title {
  display: flex;
  align-items: center;
  font-weight: 600;
}
</style>

